import React from 'react'

const ContentAdmin = () => {
  return (
    <div className="content-wrapper">
      Content Admin
    </div>
  )
}

export default ContentAdmin
